<template>
  <v-container class="elevation-3">
    <v-row>
      <v-col cols="1"></v-col>
      <v-col class="mt-5">
        <span class="input-text-size text-center">Current Posting Period : </span>
      </v-col>
      <v-col>
        <ClarionDateControl class="input-text-size" :isDisabled="true"
        :isToggle="false" v-model="editItem.curPostPerFromDate"
        label="From Date" />
      </v-col>
      <v-col>
        <ClarionDateControl class="input-text-size" :isDisabled="true"
        :isToggle="false" v-model="editItem.curPostPerToDate"
        label="To Date" />
      </v-col>
      <v-col class="mt-2 mb-2">
        <v-btn color="primary" rounded dense small @click="handleUnpstTrans">
          Find Unposted Transactions
        </v-btn>
        <v-btn color="primary" rounded dense small class="mt-2"
        :disabled="(!isSuperAdmin && !enableMonthTotBtn) || isSettingNewDates"
        @click="handleEndOfMthTot">
          Check End of Month Totals
        </v-btn>
        <Loader v-if="isLoading" />
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="mt-2 mb-2">
      <v-col cols="1"></v-col>
      <v-col cols="5">
        <v-row justify="start">
          <v-col cols="6">
            <p class="input-text-size text-center
            d-flex justify-start">Previous Uncollected Tax Amount</p>
            <p class="input-text-size text-center
            d-flex justify-start">Total Adjustments</p>
            <p class="input-text-size text-center
            d-flex justify-start">Total Payments</p>
            <p class="input-text-size text-center
            d-flex justify-start">New Tax Roll</p>
            <p class="input-text-size text-center
            d-flex justify-start">New Uncollected Tax Amount</p>
          </v-col>
          <v-col cols="5">
            <p class="input-text-size text-center
            d-flex justify-start">: {{ postingAmtDet.prevUncolAmt }}</p>
            <p class="input-text-size text-center
            d-flex justify-start">: {{ postingAmtDet.totAdjAmt }}</p>
            <p class="input-text-size text-center
            d-flex justify-start">: {{ postingAmtDet.totPayAmt }}</p>
            <p class="input-text-size text-center
            d-flex justify-start">: {{ postingAmtDet.newTaxRollAmt }}</p>
            <p class="input-text-size text-center
            d-flex justify-start">: {{ postingAmtDet.newUncolAmt }}</p>
          </v-col>
        </v-row>
        <h2 class="mt-n5 ml-5 d-flex justify-start" style="color: red;">
        {{ balancedOrNotMessage }}</h2>
        <v-btn color="primary" class="mr-4" rounded dense small @click="printTaxRollAudit">
          Print Tax Roll Audit
        </v-btn>
        <v-btn color="primary" rounded dense small @click="printTaxrollSummary">
          Print Taxroll Summary
        </v-btn>
      </v-col>
      <v-col cols="5">
        <p class="input-text-size text-center mt-8">New Posting Period</p>
        <v-row class="mt-5">
          <v-col>
            <ClarionDateControl class="input-text-size" :isDisabled="enableIsNewDate"
            :isToggle="false" v-model="newCurPostPerFromDate" label="From Date" />
          </v-col>
            <v-col>
            <ClarionDateControl class="input-text-size" v-model="newCurPostPerToDate"
            :isToggle="false" :isDisabled="enableIsNewDate" label="To Date" />
          </v-col>
        </v-row>
        <v-btn color="primary" rounded dense small class="mt-4"
        :loading="isSettingNewDates" :disabled="enableIsNewDate || isSettingNewDates"
        @click="updateSetNewDates">
          Set New Dates
        </v-btn>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>
    <PostingPeriodDialog :baseCrudKey="baseCrudKey" />
  </v-container>
</template>

<script>
import {
  mapActions,
  mapMutations,
  mapState,
} from 'vuex';
import ClarionDateControl from '@/components/common/ClarionDateControl.vue';
import {
  amountFormat,
} from '../../../../../util/shared/vue-global';
import PostingPeriodDialog from './PostingPeriodDialog.vue';
import Loader from '../../../common-utils/loader.vue';
import { taxConfigScope } from '../../../../../util/shared/system-config-scopes';
import { toIsoDate, toShortDate } from '../../../../../util/shared/tmc-global';
import { clients } from '../../../../../util/clients';
import { getRawJwt } from '../../../../../util/jwt';
import '../../../../../assets/style.css';
import { isAuthorised } from '../../../../../store/auth/token';
import { authRoles } from '../../../../../router/roleGroups';

const { backendRest } = clients.direct;

export default {
  name: 'PostingPeriod',
  data() {
    return {
      baseCrudKey: 'postingPeriodDialog',
      enableMonthTotBtn: false,
      enableIsNewDate: true,
      isLoading: false,
      // True from the Set New Dates click until the whole roll has finished (balance re-check,
      // reports, config save); `isLoading` only covers the balance check.
      isSettingNewDates: false,
      postingAmtDet: {
        prevUncolAmt: 0.00,
        totAdjAmt: 0.00,
        totPayAmt: 0.00,
        newTaxRollAmt: 0.00,
        newUncolAmt: 0.00,
        totalStillDue: 0.00,
      },
      balancedOrNotMessage: '',
      newCurPostPerFromDate: '',
      newCurPostPerToDate: '',
    };
  },
  created() {
    this.onCreatedFunction();
  },
  computed: {
    ...mapState({
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    editItem() {
      return this.taxSettingItem;
    },
    isSuperAdmin() {
      if (isAuthorised(authRoles.SuperAdmin)) {
        return true;
      }
      return false;
    },
  },
  components: {
    ClarionDateControl,
    PostingPeriodDialog,
    Loader,
  },
  methods: {
    amountFormat,
    ...mapMutations('base/crud', [
      'setIsVisible',
    ]),
    ...mapActions('tax/taxPstPeriod', [
      'loadTaxPostingPeriod',
      'getTaxPostingPeriodAmts',
      'generateTaxPostingPeriodReportsInBackend',
    ]),
    ...mapActions('SystemConfig', [
      'loadConfig', 'updateConfig',
    ]),
    ...mapActions('tax/taxInquires', [
      'callToUpdateTaxGlobalVariable',
    ]),
    ...mapActions(['flashWarn', 'flashError']),
    getAuthToken() {
      return getRawJwt();
    },
    urlEncodeObject(obj) {
      return new URLSearchParams(obj).toString();
    },
    async onCreatedFunction() {
      await this.loadConfig({ requiredScope: 'taxConfig' });
      const { curPostPerToDate } = this.editItem;
      const newCurDatePlusOne = new Date(curPostPerToDate);
      // Add 1 days to the current posting period to get the new posting period
      newCurDatePlusOne.setDate(newCurDatePlusOne.getDate() + 1);
      this.newCurPostPerFromDate = toShortDate(newCurDatePlusOne);

      // Get the last day of the month of the new posting period
      const newCurDateForToDate = new Date(newCurDatePlusOne.getFullYear(),
        newCurDatePlusOne.getMonth() + 1, 0);
      // Add 1 days, so the toshortdate will be working correctly
      newCurDateForToDate.setDate(newCurDateForToDate.getDate() + 0);
      this.newCurPostPerToDate = toShortDate(newCurDateForToDate);
    },
    async handleEndOfMthTot() {
      if (!!this.editItem.curPostPerFromDate && !!this.editItem.curPostPerToDate) {
        const criteria = {
          fromDate: toIsoDate(this.editItem.curPostPerFromDate),
          toDate: toIsoDate(this.editItem.curPostPerToDate),
        };
        this.isLoading = true;
        const res = await this.getTaxPostingPeriodAmts({ criteria }).finally(() => {
          this.isLoading = false;
        });
        this.postingAmtDet = {
          prevUncolAmt: amountFormat(res.prevUncolAmt),
          totAdjAmt: amountFormat(res.totAdjAmt),
          totPayAmt: amountFormat(res.totPayAmt),
          newTaxRollAmt: amountFormat(res.newTaxRollAmt),
          newUncolAmt: amountFormat(res.newUncolAmt),
          totalStillDue: amountFormat(res.totalStillDue),
        };
        // Trust the server's flag - it compares in whole cents against the same figures it
        // will re-check at roll time, so the button state and the gate cannot disagree.
        if (res.balanced) {
          this.balancedOrNotMessage = 'Balanced and OK';
          this.enableIsNewDate = false;
        } else {
          this.balancedOrNotMessage = 'Out of Balance';
          this.enableIsNewDate = true;
        }
      }
    },
    async handleUnpstTrans() {
      this.balancedOrNotMessage = '';
      if (!!this.editItem.curPostPerFromDate && !!this.editItem.curPostPerToDate) {
        const criteria = {
          fromDate: toIsoDate(this.editItem.curPostPerFromDate),
          toDate: toIsoDate(this.editItem.curPostPerToDate),
        };
        const res = await this.loadTaxPostingPeriod({ criteria });
        if (res.adjustmentList.length || res.paymentList.length) {
          this.setIsVisible([this.baseCrudKey, true]);
        }
        this.enableMonthTotBtn = !res.adjustmentList.length && !res.paymentList.length;
      } else this.flashWarn('Please add dates in Tax Setting');
    },
    async updateSetNewDates() {
      if (this.isSettingNewDates) return;
      this.isSettingNewDates = true;
      try {
        await this.setNewDates();
      } finally {
        this.isSettingNewDates = false;
      }
    },
    async setNewDates() {
      const criteria = {
        fromDate: toIsoDate(this.editItem.curPostPerFromDate),
        toDate: toIsoDate(this.editItem.curPostPerToDate),
      };
      // Re-run the balance check on the server IMMEDIATELY before writing. The check that
      // un-disabled this button ran whenever the user last clicked "Check End of Month
      // Totals" - possibly hours and a full day of posting ago. Comanche rolled at 21:01 on
      // 08-03 on a morning's balance, with 554,691.90 of activity keyed in between.
      // Everything below uses `fresh`, never the cached postingAmtDet.
      this.isLoading = true;
      const fresh = await this.getTaxPostingPeriodAmts({ criteria }).finally(() => {
        this.isLoading = false;
      });
      if (!fresh || !fresh.balanced) {
        if (fresh) {
          // Show what it actually is now, so the clerk can see what moved.
          this.postingAmtDet = {
            prevUncolAmt: amountFormat(fresh.prevUncolAmt),
            totAdjAmt: amountFormat(fresh.totAdjAmt),
            totPayAmt: amountFormat(fresh.totPayAmt),
            newTaxRollAmt: amountFormat(fresh.newTaxRollAmt),
            newUncolAmt: amountFormat(fresh.newUncolAmt),
            totalStillDue: amountFormat(fresh.totalStillDue),
          };
        }
        this.balancedOrNotMessage = 'Out of Balance';
        this.enableIsNewDate = true;
        this.flashError('The posting period no longer balances - activity has been posted since'
          + ' the last check. Re-run Check End of Month Totals before setting new dates.');
        return;
      }
      await this.generateTaxPostingPeriodReportsInBackend({ criteria });
      const item = taxConfigScope.mergeForPersist(this.editItem, {
        prevUncollTaxAmt: amountFormat(fresh.newUncolAmt),
        curPostPerFromDate: this.newCurPostPerFromDate,
        curPostPerToDate: this.newCurPostPerToDate,
      });
      /* Log audit not needed for this screen */
      await this.updateConfig({ calledScope: 'taxConfig', item });
      this.callToUpdateTaxGlobalVariable();
      this.enableIsNewDate = true;
      this.enableMonthTotBtn = false;
      this.balancedOrNotMessage = '';
      this.postingAmtDet = {
        prevUncolAmt: 0.00,
        totAdjAmt: 0.00,
        totPayAmt: 0.00,
        newTaxRollAmt: 0.00,
        newUncolAmt: 0.00,
        totalStillDue: 0.00,
      };
    },
    printTaxRollAudit() {
      const criteria = {
        token: this.getAuthToken(),
        fromDate: toIsoDate(this.editItem.curPostPerFromDate),
        toDate: toIsoDate(this.editItem.curPostPerToDate),
        hideTheTaxDueWhichAreZero: true,
      };
      const to = `taxInquiry/taxroll-audit-for-posting-period?${this.urlEncodeObject(criteria)}`;
      const toUrl = `${backendRest.defaults.baseURL}/${to}`;
      window.open(toUrl);
    },
    printTaxrollSummary() {
      const criteria = {
        token: this.getAuthToken(),
      };
      const to = `taxInquiry/taxroll-summary-for-posting-period?${this.urlEncodeObject(criteria)}`;
      const toUrl = `${backendRest.defaults.baseURL}/${to}`;
      window.open(toUrl);
    },
  },
};
</script>
